module.exports = __webpack_public_path__ + "static/media/creature-arm-left.ab4f3225.svg";